import React from 'react';
import { INPUT_WITH_CURRENCY } from '../../constants/general';

export interface IProps {
  currency: string;
  onChange: (event: { target: { value: string; }; }) => void
  value: string;
  id: string;
  containerClassName: string,
  currencyClassName: string,
  inputCLassName: string,
  inputRef: React.Ref<HTMLInputElement>,
  handleKeyDown?: () => void,
  eventKey?: string,
}

const InputWithCurrency = ({
  currency,
  value,
  onChange,
  id,
  containerClassName,
  currencyClassName,
  inputCLassName,
  inputRef,
  handleKeyDown,
  eventKey,
}: IProps) => {
  const { INITIAL_MARGIN, SYMBOL_STEP } = INPUT_WITH_CURRENCY;
  return (
    <div className={containerClassName}>
      <span className={`absolute mt-[1.4rem] ${currencyClassName}`} style={{ marginLeft: `${INITIAL_MARGIN - (value.length * SYMBOL_STEP)}px` }}>{currency}</span>
      <input
        onKeyDown={(event) => {
          if (handleKeyDown && eventKey && event.key === eventKey) {
            handleKeyDown();
          }
        }}
        autoComplete='off'
        ref={inputRef as React.Ref<HTMLInputElement>}
        id={id}
        value={value}
        onChange={onChange}
        type='text'
        className={inputCLassName}
      />
    </div>
  );
};

export default InputWithCurrency;
